export default "__VITE_ASSET__Do$T$$Yy__"